import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { Base } from "src/app/shared/model/core/base.model";
import { Area } from "src/app/shared/model/empleado/area.model";
import { ComentarioSolicitud } from "src/app/shared/model/empleado/comentario-solicitud.model";
import { Empleado } from "src/app/shared/model/empleado/empleado.model";
import { SolicitudVaciones } from "src/app/shared/model/empleado/solicitudVaciones.model";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";
import { environment } from "src/environments/environment";

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class SolicitudVacacionesService{

    consultaComentarioRechazo(consultaObject: ConsultaList<ComentarioSolicitud>) {
      return this.httpClient.post<ConsultaList<ComentarioSolicitud>>(UrlConstantes.consultaComentarioRechazo, consultaObject);
    }
    consultaCantidadSolicitudes(consultaObject: ConsultaList<SolicitudVaciones>) {
      return this.httpClient.post<Base>(UrlConstantes.consultaCantidadSolicitudes, consultaObject);
    }
    consultarAreaxUser(url: string) {
      return this.httpClient.post<ConsultaList<Empleado>>(url, {});
    }
    consultaSolicitudesPaginacion(consultaObject: ConsultaList<SolicitudVaciones>) {
      return this.httpClient.post<ConsultaList<SolicitudVaciones>>(UrlConstantes.consultaSolicitudesVacaciones, consultaObject);
    }
    consultaEmpleadosxArea(url: string, id_area: number) {
            return this.httpClient.post<ConsultaList<Empleado>>(url, id_area, {});
    }
    constructor(private httpClient: HttpClient) { }
    
    guardarSolicitud(solicitud: SolicitudVaciones) {
        return this.httpClient.post<SolicitudVaciones>(UrlConstantes.guardaSolicitud, solicitud);
    }

    consultaSolicitudesAreaOUsuario(consultaObject: ConsultaList<SolicitudVaciones>) {
      return this.httpClient.post<ConsultaList<SolicitudVaciones>>(UrlConstantes.consultaSolicitudesAreaOUsuario, consultaObject);
    }

    guardaComentarioRechazo(comentario: ComentarioSolicitud){
      return this.httpClient.post<ComentarioSolicitud>(UrlConstantes.guardaComentarioRechazo, comentario);
    }

    generarReporteSolicitud(url: string, param: any) {
      const httpParams = new HttpParams()
      .set('param', String(param));

  const headers = new HttpHeaders({
      'Content-Type': 'application/pdf',
      'Authorization': btoa('WEB'),
      'X-Requested-With': 'XMLHttpRequest'
  });
  return this.httpClient.get(url, {
      params: httpParams,
      headers: headers,
      responseType: 'arraybuffer'
  });
  }
}